import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe za pretvaranje trajanja u sekundama u čitljiv tekstualni format (h min s).
 */
@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  /**
   * Pretvara broj sekundi u formatirani tekst (npr. "1h 2min 3s").
   * @param value Trajanje u sekundama.
   * @returns Formatirani tekst trajanja.
   */
  transform(value: number): string {
    
    if (isNaN(value) || value < 0) return '0s';

    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    if(hours == 0 && minutes == 0){
      return `${seconds}s`;
    } else if(hours == 0 ){
      return `${minutes}min ${seconds}s`;
    }else return `${hours}h ${minutes}min ${seconds}s`;

  }

}
